export function PostData( userData) {
    let as=userData.mobile;
    console.log(as);
    let BaseURL = 'lefufooold/api/login?mobile='+as+'';
    //let BaseURL = 'http://localhost/PHP-Slim-Restful/api/';
    return new Promise((resolve, reject) =>{
        fetch(BaseURL,  {
            method: 'POST',


        }, {mode: 'cors'})
            .then((response) => response.json())
            .then((res) => {
                resolve(res);
                console.log(res);

            })
            .catch((error) => {
                reject(error);
            });
    });
}